import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, DropdownButton } from 'react-bootstrap';

export const SelectLanguage = (props) => {        
    const { i18n } = useTranslation();

    const getLanguageText = (language) => {
        if (!language)
            return ""; 
            
        const languages = [ { key: "en", text: "English" }, { key: "fr", text: "Français" } ]

        const prefix = language.substr(0, 2);
        const value  = languages.filter(p => p.key === prefix) || languages.filter(p => p.key === "en");
        
        return `${value[0].text} `;
    }

    return (
        <DropdownButton variant="" alignRight title={getLanguageText(i18n.language)} size="sm">
            <Dropdown.Item onClick={() => i18n.changeLanguage("en")}>English</Dropdown.Item>
            <Dropdown.Item onClick={() => i18n.changeLanguage("fr")}>Français</Dropdown.Item>
        </DropdownButton>
    )
}